<template>
    <div>
        <div class="hidden sm:block relative py-6">
            <div class="flex justify-center">
                <img class="logo-size" src="@/assets/logo/tipcoin-logo-top.png">
            </div>
            <ProfileLogin :modalController="modalController"></ProfileLogin>
        </div>
        <div class="sm:hidden relative mobile-top">
            <div class="flex justify-center pt-2">
                <img class="logo-mobile-size" src="@/assets/logo/tipcoin-logo-top.png">
            </div>
            <div class="absolute right-1 top-4">
                <OutlineBlueBtn>
                    <a href="tel:1736">
                        <div class="flex justify-center px-2">
                            <div class="flex-initial">
                                <img src="@/assets/icon/call-icon.png" class="w-4 pt-2px" />
                            </div>
                            <div class="pl-1 text-18">
                                {{lbl.topbar.call_center}}
                            </div>
                        </div>
                    </a>
                </OutlineBlueBtn>
            </div>
        </div>
    </div>
</template>
<script>
import OutlineBlueBtn from "@/components/Button/OutlineBlueBtn.vue";
import ProfileLogin from "@/components/Layout/TopBar/component/ProfileLogin.vue"
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: 'TopBar',
    mixins: [LocaleMixin],
    components: {
        OutlineBlueBtn,
        ProfileLogin
    },
    props: {
        modalController: { type: Object, required: true },
    },
    data: function(){
        return {
            title: 'โปรไฟล์'
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .logo-size {
        width: 100px;
        height: 90px;
    }
    .logo-mobile-size {
        width: 65px; //53px
        height: 58px;
    }
    .mobile-top {
        height: $topbar-height-mobile;
    }
</style>
